import { track } from '@vercel/analytics';

// Every custom event goes through here, so switching analytics provider means editing only this file.
// Events show up in the Vercel dashboard under Analytics → Events (no database needed: Vercel stores them).
// Property values must be strings, numbers, booleans or null.
export const trackEvent = (name, properties) => {
    try {
        track(name, properties);
    } catch {
        // Analytics must never break the page (e.g. blocked by an ad blocker)
    }
};
